<template>
  <div class="content">
    <div class="content-item">
      <div class="box-head">
        <div class="box-title">
          <span></span>
          <div>人均使用时长</div>
          <span>本周</span>
        </div>
      </div>
      <div class="box-body">
        <div class="time">
          <span class="time-1">{{ time }}h</span>
          <span class="time-2">/人天</span>
        </div>
      </div>
    </div>
    <div class="content-item">
      <div class="box-head">
        <div class="box-title">
          <span></span>
          <div>活跃度</div>
          <span>本周</span>
        </div>
      </div>
      <div class="box-body">
        <div class="time">
          <span class="time-1">{{ value }}%</span>
          <span class="time-2">活跃度</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      time: 0,
      value: 0,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      const res = await axios.get(this.$api.usageDuration);
      this.time = res.data.data;
      const res2 = await axios.get(this.$api.activation);
      this.value = res2.data.data;
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  display: flex;
  justify-content: space-between;
  height: 100%;
  .content-item {
    width: 48%;
    display: flex;
    flex-direction: column;
    background-color: rgba(83, 98, 255, 0.1);
    border: 2px solid rgba(255, 255, 255, 0.26);
    border-radius: 12px;
    .box-head {
      position: relative;
      .box-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 15px 0 5px 0;
        div {
          width: 11rem;
          height: 2.5rem;
          border: 2px solid #4668ec;
          box-shadow: 0 0 8px 0 rgba(128, 173, 255, 0.5),
            inset 0 0 20px 0 rgba(26, 242, 255, 0.1);
          border-radius: 8px;
          font-size: 1.1rem;
          font-weight: normal;
          display: flex;
          align-items: center;
          justify-content: center;
          font-style: italic;
        }
        span {
          width: 2rem;
          color: #0087f9;
          font-size: 0.875rem;
          align-self: end;
          margin-left: 0.625rem;
        }
      }
    }
    .box-body {
      flex: 1;
      background-color: rgba(7, 65, 122, 0.2);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .title {
        background: url("/static/img/tk.png");
        background-repeat: no-repeat;
        background-size: cover;
        -webkit-background-size: cover;
        -o-background-size: cover;
        background-position: center 0;
        padding: 0.3125rem 1.25rem;
        font-weight: bold;
        margin-top: 1.25rem;
      }
      .time {
        background: url("/static/img/rjsysc@3x.png");
        background-repeat: no-repeat;
        background-size: cover;
        -webkit-background-size: cover;
        -o-background-size: cover;
        background-position: center 0;
        height: 120px;
        width: 120px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        transform: scale(1.2);
        .time-1 {
          font-weight: bold;
          color: #00edff;
          font-size: 1.5rem;
        }
        .time-2 {
          font-size: 0.75rem;
          color: #00edff;
        }
      }
      .act {
        background: url("/static/img/hyd@3x.png");
        background-repeat: no-repeat;
        background-size: cover;
        -webkit-background-size: cover;
        -o-background-size: cover;
        background-position: center 0;
        margin-top: 1.25rem;
        height: 120px;
        width: 120px;
      }
    }
  }
}

.box-line-1 {
  position: absolute;
  top: 0;
  left: 0;
  width: 10px;
  height: 10px;
  border-top: 1px solid #44c4ff;
}
.box-line-2 {
  position: absolute;
  top: 0;
  right: 0;
  width: 10px;
  height: 10px;
  border-top: 1px solid #44c4ff;
}
.box-line-3 {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 10px;
  height: 10px;
  border-bottom: 1px solid #44c4ff;
}
.box-line-4 {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 10px;
  height: 10px;
  border-bottom: 1px solid #44c4ff;
}
</style>
